/* eslint-disable no-console */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-restricted-syntax */
/* eslint-disable jsx-a11y/label-has-associated-control */
import moment from "moment-business-days";
import React, { useCallback, useEffect, useMemo, useState } from "react";

import DataTable, { createTheme } from "react-data-table-component";
import { Helmet } from "react-helmet";
import { withRouter } from "react-router";
import { toast } from "react-toastify";
import { UncontrolledTooltip } from "reactstrap";
import Dropdown from "react-bootstrap/Dropdown";
import { ArrowRight, Download, FileInput, Plus, Save, Share2, SlidersHorizontal, SquarePen, X } from "lucide-react";
import DatePicker from "react-datepicker";
import { humanDateFormat, OrdenesDeVentaKpiIcons } from "../../../config/constants";
import { BlurSpinner } from "../../components/BlurSpinner";
import Breadcrumb from "../../components/common/breadcrumb";
import { ShowSearchBar } from "../../components/SearchBar";
import { useSearchBar } from "../../components/SearchBar/context/SearchBarContext";

import useFetcher from "../../hooks/useFetcher";
import usePaging from "../../hooks/usePaging";
import { getNotasDePedidoCategory } from "../../services/notasDePedidoServices";
import { tableCustomStylesNP } from "../../ui/table";
import { ButtonPrimary, ButtonSecondary, CustomDropdown, IconButton, SimpleButton, TicketingExportButton } from "../../ui/buttons";
import { CustomLabel } from "../../ui/labels";
import KpiCardNP from "../../components/kpiCard/KpiCardNP";
import SelectV2 from "../../components/SelectV2";
import AsyncSelectV2 from "../../components/SelectV2/AsyncSelectV2";
import { getColorByEstado } from "../NotasDePedido/utils";
import { fetchServicios } from "../../services/servicioServices";
import DateRangeComponentV2 from "../../components/DateRangeV2";
import { PeriodoActualContainer, PeriodoActualFecha, PeriodoActualLabel, PeriodoActualTitle, StatusTagButton, TagButton } from "./styles";
import {
  calcularInvoiceDate,
  formatDateToDDMMYYYY,
  formatearTotal,
  formatPeriodo,
  getEstadoByValueOV,
  getIconByStatus,
  parseDDMMYYYYtoDate,
  promiseOptions,
} from "./utils";
import {
  exportOrdenesDeVenta,
  fetchCategoriasOrdenDeVenta,
  fetchClientesOrdenDeVenta,
  fetchSubClientesOrdenDeVentaPaginados,
  fetchSucursalesOrdenDeVenta,
  getOrdenesDeVenta,
  multiPatchEstados,
  updateOrdenDeVenta,
} from "../../services/moduloOrdenDeVentaServices";
import { dowloadMultiZip, downloadFile, generateMultiZip, getProccessStatus } from "../../services/fileServices";
import Spinner from "../../components/Spinner";
import NuevaOrdenDeVentaModal from "./NuevaOV/NuevaOrdenDeVentaModal";
import ConfirmModal from "../../components/ConfirmModal";
import { StylesDatePicker } from "../../ui/stylesDatePicker";
import { getPeriodoActual, updatePeriodoActual } from "../../services/periodoActualServices";
import { useAuth } from "../../context/AuthContext";
import modulos from "../../mocks/modulos";

createTheme("ordenDeVenta", {
  context: {
    background: "#F7F7F7",
    padding: "0px",
  },
});

const ModuloOrdenesDeVenta = ({ history, location }) => {
  const { searchBarText } = useSearchBar();
  const { currentUser } = useAuth();
  const isAdmin = currentUser && currentUser.haveAdminAccess(modulos.ORDENES_DE_VENTA);
  const isAudit = currentUser && currentUser.haveAuditAccess(modulos.ORDENES_DE_VENTA);

  const [servicios, isLoadingServicios] = useFetcher(fetchServicios, undefined, "fetchServicios");
  const [subclients, isLoadingSubclients] = useFetcher(fetchSubClientesOrdenDeVentaPaginados, [{ page: 1, perpage: 100 }]);
  const [clientesDefault, isLoadingClientes] = useFetcher(fetchClientesOrdenDeVenta, [{ page: 1, perpage: 50 }]);
  const [sucursales, isLoadingSucursales] = useFetcher(fetchSucursalesOrdenDeVenta, undefined, "fetchSucursalesOrdenDeVenta");
  const [categories, isLoadingCategories] = useFetcher(getNotasDePedidoCategory, undefined, "getNotasDePedidoCategory");
  const [categoriesOV, isLoadingCategoriesOV] = useFetcher(fetchCategoriasOrdenDeVenta, undefined, "fetchCategoriasOrdenDeVenta");
  const [periodoActualData, isLoadingPeriodoActual, , , refetchPeriodoActual] = useFetcher(getPeriodoActual);
  const subservicios = categoriesOV && categoriesOV.clienteSubservicio;
  const pagingController = usePaging(getOrdenesDeVenta);
  const [selectedRows, setSelectedRows] = useState([]);
  const [ordenData, setOrdenData] = useState(null);
  const [downloadingFileId, setDownloadingFileId] = useState(null);
  const [confirmModal, setConfirmModal] = useState(false);
  const [toggleCleared, setToggleCleared] = useState(false);
  const [nuevaOrdenDeVentaForm, setNuevaOrdenDeVentaForm] = useState(false);
  const [estadosCat, setEstadosCat] = useState([]);
  const [enviandoAFacturar, setEnviandoAFacturar] = useState(null);
  const params = location.search || new URLSearchParams();
  const [modifyingPeriod, setModifyingPeriod] = useState(false);
  const [periodoActual, setPeriodoActual] = useState(null);

  let selectedSubservicios = [];
  if (Array.isArray(pagingController.query.subservicio)) {
    selectedSubservicios = pagingController.query.subservicio;
  } else if (pagingController.query.subservicio) {
    selectedSubservicios = pagingController.query.subservicio.split(",");
  }

  const activeFilterKeys = useMemo(() => {
    const keys = [];
    const filtroClaves = ["servicio", "subservicio", "razonSocial", "sucursal", "subcliente", "startDate", "endDate", "businessLine"];

    // Si params es un string, conviértelo a URLSearchParams
    const searchParams = typeof params === "string" ? new URLSearchParams(params) : params;

    filtroClaves.forEach((clave) => {
      if (searchParams.has(clave) && searchParams.get(clave)) {
        keys.push(clave);
      }
    });

    return keys;
  }, [params]);

  const loadOptions = useCallback((inputValue) => {
    return promiseOptions(inputValue, "query", fetchSubClientesOrdenDeVentaPaginados, (e) => {
      const legajo = e.numeroDeLegajo;
      const legajoFormateado = legajo && legajo.replace(/\.?0+$/, "").padStart(7, "0");
      return {
        label: `${legajoFormateado} - ${e.razonSocial}`,
        value: e.itemId,
      };
    });
  });

  const loadClientesOptions = useCallback((inputValue, searchParam) => {
    if (searchParam) {
      return promiseOptions(inputValue, searchParam, fetchClientesOrdenDeVenta, (e) => {
        return { label: e.razonSocial, value: e.razonSocial, cuit: e.cuit, id: e.id };
      });
    }
    return promiseOptions(inputValue, "razonSocial", fetchClientesOrdenDeVenta, (e) => {
      return { label: e.razonSocial, value: e.razonSocial, cuit: e.cuit, id: e.id };
    });
  });

  const reloadOrdenesDeVenta = () => {
    pagingController.reloadData(history.location);
  };

  // const estados = categories && categories.estadoNP;
  const businessLineEnum = categories && categories.businessLine;

  estadosCat.sort((a, b) => {
    const order = "123 11 48567";
    return order.indexOf(a.id) - order.indexOf(b.id);
  });

  // se obtienen los servicios asignados al PI x metadata de los
  // permisos del user y se configura el filtro para mostrar las notas correspondientes

  useEffect(() => {
    pagingController.setFilterValue({ query: searchBarText });
  }, [searchBarText]);

  useEffect(() => {
    if (categories.estadoNP) {
      const estados = categories.estadoNP.ordenDeVenta;
      const filtered = estados.filter((e) => e.id === 1 || e.id === 7);
      setEstadosCat(filtered);
    }
  }, [categories]);

  useEffect(() => {
    if (periodoActualData && periodoActualData.length > 0) {
      const desde = moment(periodoActualData[0].startDate).format("DD/MM/YYYY");
      const hasta = moment(periodoActualData[0].endDate).format("DD/MM/YYYY");
      const periodo = periodoActualData[0].title.toUpperCase();
      const editado = moment(periodoActualData[0].updatedAt).format("DD/MM");
      const { id } = periodoActualData[0];
      setPeriodoActual({ desde, hasta, periodo, editado, id });
    }
  }, [periodoActualData]);

  const clientesDefaultOptions = useMemo(() => {
    const baseOptions = clientesDefault.rows
      ? clientesDefault.rows
          .map((e) => {
            return { label: e.razonSocial, value: e.razonSocial, cuit: e.cuit, id: e.id };
          })
          .sort((a, b) => (a.label > b.label ? 1 : -1))
      : [];

    // Add placeholder options for query values not in default options
    if (pagingController.query.razonSocial) {
      const selectedValues = Array.isArray(pagingController.query.razonSocial) ? pagingController.query.razonSocial : pagingController.query.razonSocial.split(",");

      selectedValues.forEach((value) => {
        if (!baseOptions.find((option) => option.value === value)) {
          baseOptions.push({
            label: value,
            value,
            cuit: null,
            id: null,
          });
        }
      });
    }

    return baseOptions.sort((a, b) => (a.label > b.label ? 1 : -1));
  }, [clientesDefault.rows, pagingController.query.razonSocial]);

  // Opciones para select de servicios
  const allServiciosOptions = servicios
    ? servicios
        .map((e) => {
          return { label: e.text, value: e.id };
        })
        .sort((a, b) => (a.label > b.label ? 1 : -1))
    : [];
  const serviciosOptions = allServiciosOptions && allServiciosOptions.length > 0 ? allServiciosOptions.filter((e) => e.value !== 1) : [];

  const subClientesOptions =
    subclients && subclients.rows && subclients.rows.length > 0
      ? subclients.rows
          .map((e) => {
            const legajo = e.numeroDeLegajo;
            const legajoFormateado = legajo && legajo.replace(/\.?0+$/, "").padStart(7, "0");

            return {
              label: `${legajoFormateado} - ${e.razonSocial}`,
              value: e.itemId,
            };
          })
          .sort((a, b) => (a.label > b.label ? 1 : -1))
      : [];

  const subserviciosOptions = subservicios
    ? subservicios
        .map((e) => {
          return { label: `${e.servicio}-${e.subservicio}`, value: e.id };
        })
        .sort((a, b) => (a.label > b.label ? 1 : -1))
    : [];

  // Opciones para select de sucursales
  const sucursalesOptions = sucursales
    ? sucursales
        .map((e) => {
          return { label: e.titulo, value: e.itemId };
        })
        .sort((a, b) => (a.label > b.label ? 1 : -1))
    : [];

  const businessLineOptions =
    businessLineEnum && businessLineEnum.type && businessLineEnum.type.length > 0
      ? businessLineEnum.type
          .map((e) => {
            return { label: e.text, value: e.id };
          })
          .sort((a, b) => (a.label > b.label ? 1 : -1))
      : [];

  const handleReactSelectChange = (selected, options) => {
    if ((options.action === "select-option" && options.option === undefined) || (options.action === "clear" && options.removedValues.length === 1)) {
      const newState = { [options.name]: selected ? selected.value : null };
      if (newState.region) {
        newState.sucursal = null;
      }
      pagingController.setFilterValue(newState);
    } else {
      const newState = { [options.name]: selected[0] ? selected.map((item) => item.value).join(",") : null };
      if (newState.region) {
        newState.sucursal = null;
      }
      pagingController.setFilterValue(newState);
    }
  };

  const handleFilterStatus = (estado) => {
    const currentEstado = pagingController.query.estado;
    const arrayEstado = currentEstado ? currentEstado.split(",") : [];
    const objEstado = estadosCat.find((objeto) => objeto.id === estado);
    const estadoId = objEstado ? objEstado.id : null;

    if (currentEstado) {
      // Verificar si el estado actual ya está presente en la lista de estados seleccionados
      const idString = JSON.stringify(estadoId);
      const isEstadoSelected = arrayEstado.includes(idString);

      // Si el estado ya está seleccionado, eliminarlo de la lista
      if (isEstadoSelected) {
        const updatedEstado = arrayEstado.filter((e) => e !== idString);

        if (updatedEstado.length === 0) {
          pagingController.setFilterValue({ estado: null });
        } else {
          pagingController.setFilterValue({ estado: updatedEstado });
        }
      }
      // Si el estado no está seleccionado, agregarlo a la lista
      else {
        const updatedEstado = [...arrayEstado, estadoId];
        pagingController.setFilterValue({ estado: updatedEstado });
      }
    } else {
      // Si no hay estados seleccionados lo agrega directamente
      pagingController.setFilterValue({ estado: estadoId });
    }
  };

  const handleDownloadFileOrdenDeVenta = async (row) => {
    setDownloadingFileId(row.idOrdenDeVenta);
    try {
      const { message } = await downloadFile({ entity: "npOrdenDeVenta", entityId: row.idOrdenDeVenta, fileId: row.fileId });
      toast.success(message);
    } catch (error) {
      toast.error(error.message);
    } finally {
      setDownloadingFileId(null);
    }
  };

  const handleDownloadZipOrdenDeVenta = async () => {
    setDownloadingFileId("zip");

    const filesId = selectedRows.map((row) => row.fileId);

    try {
      const { message, jobId } = await generateMultiZip({ filesId, fileName: "OrdenesDeVentaZip" });
      toast.success(message);

      let status = "waiting";
      let token = null;
      const maxRetries = 10;
      const delayMs = 2000;
      let attempts = 0;

      /* eslint-disable no-await-in-loop */
      while (["waiting", "active", "delayed"].includes(status) && attempts < maxRetries) {
        try {
          const result = await getProccessStatus({ jobId });

          status = result && result.status;
          token = result && result.token;

          if (status === "completed") break;
          if (["failed", "paused"].includes(status)) {
            toast.error(`El proceso no pudo completarse. Estado: ${status}`);
            return;
          }
        } catch (pollError) {
          toast.error("Error verificando el estado del ZIP.");
          console.error("Polling error:", pollError);
          throw pollError;
        }

        await new Promise((res) => setTimeout(res, delayMs));
        // eslint-disable-next-line no-plusplus
        attempts++;
      }
      /* eslint-enable no-await-in-loop */

      if (status !== "completed" || !token) {
        toast.error("No se pudo completar la generación del ZIP. Inténtelo nuevamente.");
        return;
      }

      try {
        await dowloadMultiZip({ zipToken: token });
        toast.success("ZIP descargado correctamente");
        setSelectedRows([]);
        setToggleCleared(!toggleCleared);
      } catch (downloadError) {
        toast.error("Error al descargar el ZIP.");
        console.error("Download error:", downloadError);
      }
    } catch (error) {
      toast.error(error.message || "Ocurrió un error inesperado.");
      console.error("General error:", error);
    } finally {
      setSelectedRows([]);
      setToggleCleared(!toggleCleared);
      setDownloadingFileId(null);
    }
  };

  const handleMultipleEnviar = async (rows) => {
    setEnviandoAFacturar("multiple");
    if (rows.length === 0) {
      toast.error("Debe seleccionar al menos una orden de venta para enviar a facturar.");
      setEnviandoAFacturar(null);
      return;
    }

    const ids = rows.filter((row) => row.estado === 1).map((row) => row.idOrdenDeVenta);
    if (ids.length === 0) {
      toast.error("Debe seleccionar al menos una orden de venta con estado 'Pendiente' para enviar a facturar.");
      setEnviandoAFacturar(null);
      return;
    }

    try {
      const invoiceDate = calcularInvoiceDate(periodoActual);
      const { message } = await multiPatchEstados({ idOrdenDeVenta: ids, estado: 2, invoiceDate });
      toast.success(message);
      pagingController.reloadData(history.location);
    } catch (error) {
      toast.error("No se pudo enviar a facturar.");
    } finally {
      reloadOrdenesDeVenta();
      setEnviandoAFacturar(null);
      setSelectedRows([]);
      setToggleCleared(!toggleCleared);
    }
  };

  const handleOrdenClicked = (row) => {
    setOrdenData(row);
    setNuevaOrdenDeVentaForm(true);
  };

  const handleClickEnviar = async (row) => {
    setEnviandoAFacturar(row.idOrdenDeVenta);
    const invoiceDate = calcularInvoiceDate(periodoActual);

    try {
      const { message } = await updateOrdenDeVenta(row.idOrdenDeVenta, { estado: 2, invoiceDate });
      toast.success(message);

      pagingController.reloadData(history.location);
    } catch (error) {
      toast.error("No se pudo enviar a facturar.");
    } finally {
      setEnviandoAFacturar(null);
    }
  };

  const handleDatesChange = (date, tag) => {
    if (!date) return;

    const formattedDate = formatDateToDDMMYYYY(date);

    setPeriodoActual((prev) => {
      const updated = {
        ...prev,
        [tag]: formattedDate,
      };

      if (tag === "desde") {
        const mes = date.toLocaleString("es-AR", { month: "long" }).toUpperCase();
        updated.periodo = mes;
      }

      return updated;
    });
  };

  const handleUpdatePeriodoActual = async () => {
    if (periodoActual.desde && periodoActual.hasta) {
      try {
        const startDate = moment(periodoActual.desde, "DD/MM/YYYY").toISOString();
        const endDate = moment(periodoActual.hasta, "DD/MM/YYYY").toISOString();

        const newPeriodo = { startDate, endDate };
        const { message } = await updatePeriodoActual(periodoActual.id, newPeriodo);
        toast.success(message);
        refetchPeriodoActual();
        setModifyingPeriod(false);
      } catch (error) {
        toast.error("No se pudo actualizar el periodo actual.");
      }
    }
  };

  const handleRowSelected = React.useCallback((state) => {
    setSelectedRows(state.selectedRows);
  }, []);

  // BOTON EXPORTAR Ordenes de venta
  const downloadOVCSV = async () => {
    toast.success("Su solicitud de exportación está siendo procesada");
    const blob = await exportOrdenesDeVenta(location.search);
    const link = document.createElement("a");
    const url = window.URL.createObjectURL(blob);
    const filename = `Ordenes de venta-${moment().format(humanDateFormat)}.csv`;
    link.href = url;
    link.setAttribute("download", filename);
    link.click();
    window.URL.revokeObjectURL(url);
  };

  const contextComponent = React.useMemo(() => {
    const totalSelected = selectedRows.length;

    return (
      <div className="w-100 d-flex justify-content-between CONTENEDOR">
        <ButtonSecondary background="#fff" border="1px solid #cccccc" padding="0px 10px" onClick={() => setToggleCleared(!toggleCleared)}>
          <div className="d-flex align-items-center">
            <p className="my-0 mr-2 bold" style={{ fontFamily: "Nunito", fontSize: "16px" }}>
              {totalSelected > 1 ? `${totalSelected} ordenes seleccionadas` : `${totalSelected} orden seleccionada`}
            </p>
            <X size={16} />
          </div>
        </ButtonSecondary>
        <div className="d-flex align-items-center">
          <ButtonSecondary key="Enviar a Facturar" onClick={() => handleMultipleEnviar(selectedRows)} disabled={isAudit}>
            {enviandoAFacturar === "multiple" ? (
              <p style={{ margin: "0", fontWeight: "800", fontSize: "16px", width: "165px" }}>Enviando... </p>
            ) : (
              <>
                <p style={{ margin: "0", fontWeight: "800", fontSize: "16px" }}>Enviar a Facturar</p>
                <FileInput className="ml-2" size={20} />
              </>
            )}
          </ButtonSecondary>
          <TicketingExportButton width="150px" type="button" key="descargar-zip" onClick={() => handleDownloadZipOrdenDeVenta(selectedRows)}>
            <p style={{ margin: "0", fontWeight: "800", fontSize: "16px", color: "#062541" }}>Descargar</p>
            <Download color="#062541" size={20} className="ml-2" />
          </TicketingExportButton>
        </div>
      </div>
    );
  }, [selectedRows, enviandoAFacturar]);

  return (
    <>
      {nuevaOrdenDeVentaForm && (
        <NuevaOrdenDeVentaModal
          toggle={(created) => {
            if (created) {
              setNuevaOrdenDeVentaForm(false);
              setConfirmModal(false);
              setOrdenData(null);
              return;
            }
            setConfirmModal(true);
          }}
          isOpen={nuevaOrdenDeVentaForm}
          reloadOrdenesDeVenta={reloadOrdenesDeVenta}
          ordenData={ordenData}
        />
      )}
      {confirmModal && (
        <ConfirmModal
          isOpen={confirmModal}
          toggle={() => {
            setConfirmModal(!confirmModal);
          }}
          handleContinuar={() => {
            setNuevaOrdenDeVentaForm(false);
            setConfirmModal(false);
            setOrdenData(null);
          }}
          handleCancelar={() => {
            setConfirmModal(false);
          }}
          title="Cerrar formulario Orden de Venta"
          text="Si cierras el formulario se perderán los cambios realizados. ¿Desea continuar?"
        />
      )}
      <Helmet>
        <title>PIN - Ordenes de Venta</title>
      </Helmet>
      <ShowSearchBar defaultValue={pagingController.query.query} />
      {!isAudit && (
        <div style={{ display: "flex", alignItems: "center", position: "absolute", right: "30px", zIndex: "1", marginTop: "30px" }}>
          <ButtonPrimary type="button" onClick={() => setNuevaOrdenDeVentaForm(true)}>
            Crear nueva
            <span className="ml-2 d-flex align-items-center">
              <Plus size={16} strokeWidth={2.25} />
            </span>
          </ButtonPrimary>
        </div>
      )}
      <Breadcrumb title="Ordenes de Venta" parent="Sistema de Ordenes de Venta" />
      <BlurSpinner isLoading={pagingController.isLoading}>
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div>
                <div className="d-flex flex-column ">
                  <div className="d-flex align-items-center mb-2" style={{ gap: "10px" }}>
                    <PeriodoActualTitle>Periodo actual:</PeriodoActualTitle>
                    {!modifyingPeriod ? (
                      <TagButton
                        type="button"
                        onClick={() => setModifyingPeriod(!modifyingPeriod)}
                        disabled={!isAdmin || isLoadingPeriodoActual || !periodoActual || !periodoActual.desde || !periodoActual.hasta}
                      >
                        {isLoadingPeriodoActual ? (
                          "Cargando..."
                        ) : (
                          <>
                            {periodoActual && periodoActual.periodo}
                            {isAdmin && <SquarePen />}
                          </>
                        )}
                      </TagButton>
                    ) : (
                      <div style={{ width: "500px", height: "25px", display: "flex", justifyContent: "space-between", alignItems: "center", gap: "5px" }}>
                        <div className="w-100">
                          <StylesDatePicker className="my-2" border>
                            <DatePicker
                              placeholder="Desde"
                              className="date-input digits w-100"
                              dateFormat="dd/MM/yyyy"
                              onChange={(e) => handleDatesChange(e, "desde")}
                              selected={parseDDMMYYYYtoDate(periodoActual.desde)}
                            />
                          </StylesDatePicker>
                        </div>
                        <div className="mt-2">-</div>
                        <div className="w-100">
                          <StylesDatePicker className="my-2" border>
                            <DatePicker
                              placeholder="Hasta"
                              className="date-input digits w-100"
                              dateFormat="dd/MM/yyyy"
                              onChange={(e) => handleDatesChange(e, "hasta")}
                              selected={parseDDMMYYYYtoDate(periodoActual.hasta)}
                            />
                          </StylesDatePicker>
                        </div>
                        <div className="d-flex align-items-center flex-column justify-content-center">
                          <IconButton onClick={() => handleUpdatePeriodoActual()}>
                            <Save size={16} />
                          </IconButton>
                          <IconButton onClick={() => setModifyingPeriod(!modifyingPeriod)}>
                            <X size={16} />
                          </IconButton>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="w-100">
                    <PeriodoActualLabel style={{ fontSize: "12px" }}>{periodoActual && periodoActual.editado && `Editado ${periodoActual.editado}`}</PeriodoActualLabel>
                  </div>
                </div>
              </div>
              <div className="d-flex align-items-center mb-3" style={{ gap: "10px" }}>
                <PeriodoActualContainer>
                  <PeriodoActualLabel>Desde</PeriodoActualLabel>
                  <PeriodoActualFecha>{periodoActual && periodoActual.desde}</PeriodoActualFecha>
                  <ArrowRight size={12} />
                  <PeriodoActualLabel>Hasta</PeriodoActualLabel>
                  <PeriodoActualFecha>{periodoActual && periodoActual.hasta}</PeriodoActualFecha>
                </PeriodoActualContainer>

                <CustomDropdown backgroundColor="#fff" box-shadow="0px 0px 4px 0px #00000040" padding="20px" toggleMaxWidth="130px">
                  <Dropdown>
                    <Dropdown.Toggle
                      className={`dropdown-toggle white-black px-2 flex align-items-center justify-content-between ${
                        activeFilterKeys && activeFilterKeys.length > 0 ? "filters-active" : ""
                      }`}
                      style={{ width: "200px" }}
                      id="dropdown-basic-filter"
                    >
                      <div className="d-flex align-items-center">
                        <SlidersHorizontal size={18} className="mr-2" />
                        Filtros {activeFilterKeys && activeFilterKeys.length > 0 && `(${activeFilterKeys.length})`}
                      </div>
                    </Dropdown.Toggle>
                    <Dropdown.Menu style={{ backgroundColor: "#fff !important" }}>
                      <div className="d-flex justify-content-end">
                        <SimpleButton
                          type="button"
                          onClick={() => {
                            const filtersToReset = activeFilterKeys.reduce((acc, key) => {
                              acc[key] = null;
                              return acc;
                            }, {});
                            pagingController.setFilterValue(filtersToReset);
                          }}
                        >
                          Borrar filtros
                        </SimpleButton>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "1rem",
                        }}
                      >
                        {/* filtro rango de fechas */}
                        <CustomLabel htmlFor="fecha">
                          Fecha Enviada
                          <DateRangeComponentV2 pagingController={pagingController} history={history} id="fecha" />
                        </CustomLabel>

                        {/* filtro razon social */}
                        <CustomLabel htmlFor="razonSocial" className="pt-0 w-100">
                          Razón Social
                          <AsyncSelectV2
                            isMulti
                            id="razonSocial"
                            name="razonSocial"
                            onChange={handleReactSelectChange}
                            value={
                              clientesDefaultOptions.filter((option) =>
                                pagingController.query.razonSocial ? pagingController.query.razonSocial.includes(option.value) : ""
                              ) || null
                            }
                            placeholder="Seleccionar..."
                            isClearable
                            isLoading={isLoadingClientes}
                            isDisabled={isLoadingClientes}
                            defaultOptions={clientesDefaultOptions}
                            loadOptions={loadClientesOptions}
                          />
                        </CustomLabel>

                        {/* filtro subcliente */}
                        <CustomLabel htmlFor="subcliente" className="pt-0 w-100">
                          Subcliente
                          <AsyncSelectV2
                            isMulti
                            id="subcliente"
                            name="subcliente"
                            onChange={handleReactSelectChange}
                            value={
                              subClientesOptions.filter((option) =>
                                pagingController.query.subcliente ? pagingController.query.subcliente.includes(option.value) : ""
                              ) || null
                            }
                            placeholder="Seleccionar..."
                            isClearable
                            isLoading={isLoadingSubclients}
                            isDisabled={isLoadingSubclients}
                            defaultOptions={subClientesOptions}
                            loadOptions={loadOptions}
                          />
                        </CustomLabel>

                        {/* filtro sucursal */}
                        <CustomLabel htmlFor="sucursal" className="pt-0 w-100">
                          Sucursal Adecco
                          <SelectV2
                            isMulti
                            id="sucursal"
                            name="sucursal"
                            onChange={handleReactSelectChange}
                            value={
                              sucursalesOptions.filter((option) => (pagingController.query.sucursal ? pagingController.query.sucursal.includes(option.value) : "")) ||
                              null
                            }
                            placeholder="Seleccionar..."
                            isClearable
                            isLoading={isLoadingSucursales}
                            isDisabled={isLoadingSucursales}
                            options={sucursalesOptions}
                          />
                        </CustomLabel>

                        {/* filtro business line */}
                        <CustomLabel htmlFor="businessLine" className="pt-0 w-100">
                          Business Line
                          <SelectV2
                            isMulti
                            id="businessLine"
                            name="businessLine"
                            onChange={handleReactSelectChange}
                            value={
                              businessLineOptions.filter((option) =>
                                pagingController.query.businessLine ? pagingController.query.businessLine.includes(option.value) : ""
                              ) || null
                            }
                            placeholder="Seleccionar..."
                            isClearable
                            isLoading={isLoadingCategories}
                            isDisabled={isLoadingCategories}
                            options={businessLineOptions}
                          />
                        </CustomLabel>

                        {/* filtro servicios */}
                        <CustomLabel htmlFor="servicio" className="pt-0 w-100">
                          Servicios
                          <SelectV2
                            isMulti
                            id="servicio"
                            name="servicio"
                            onChange={handleReactSelectChange}
                            value={
                              serviciosOptions.filter((option) => (pagingController.query.servicio ? pagingController.query.servicio.includes(option.value) : "")) || null
                            }
                            placeholder="Seleccionar..."
                            isClearable
                            isLoading={isLoadingServicios}
                            isDisabled={isLoadingServicios}
                            options={serviciosOptions}
                          />
                        </CustomLabel>

                        {/* filtro subservicios */}
                        <CustomLabel htmlFor="subservicio" className="pt-0 w-100">
                          Subservicios
                          <SelectV2
                            isMulti
                            id="subservicio"
                            name="subservicio"
                            onChange={handleReactSelectChange}
                            value={subserviciosOptions.filter((option) => selectedSubservicios.includes(String(option.value))) || null}
                            placeholder="Seleccionar..."
                            isClearable
                            isLoading={isLoadingCategoriesOV}
                            isDisabled={isLoadingCategoriesOV}
                            options={subserviciosOptions}
                          />
                        </CustomLabel>
                      </div>
                    </Dropdown.Menu>
                  </Dropdown>
                </CustomDropdown>
              </div>

              <div className="table-responsive support-table border">
                <DataTable
                  title={
                    <div className="d-flex justify-content-between align-items-end m-2">
                      {isLoadingCategories ? (
                        <div />
                      ) : (
                        <>
                          {/* ----------------- CARDS DE STATUS ---------------- */}
                          <div
                            className="d-flex flex-wrap"
                            style={{
                              gap: "10px",
                              width: "60%",
                            }}
                          >
                            {estadosCat && pagingController.statusStats ? (
                              estadosCat.map((estado) => {
                                const statusDef = {
                                  id: estado.id,
                                  text: estado.text,
                                  color: getColorByEstado(estado.id),
                                };
                                const value = { count: pagingController.statusStats[estado.text] || 0 };
                                return (
                                  OrdenesDeVentaKpiIcons[estado.id] && (
                                    <div
                                      key={estado.id}
                                      style={{
                                        flex: "1 1 200px",
                                        maxWidth: "250px",
                                      }}
                                    >
                                      <KpiCardNP
                                        statusDef={statusDef}
                                        icon={OrdenesDeVentaKpiIcons[estado.id]}
                                        value={value}
                                        total={pagingController.statusStats.Total || 0}
                                        onClick={handleFilterStatus}
                                        selected={pagingController.query.estado ? pagingController.query.estado.split(",").map(Number).includes(estado.id) : false}
                                      />
                                    </div>
                                  )
                                );
                              })
                            ) : (
                              <div className="d-flex align-items-center w-100">
                                <p className="mb-0">Sin informacion de KPI</p>
                              </div>
                            )}
                          </div>
                        </>
                      )}

                      {pagingController.totalRows > 0 && (
                        <div className="d-flex justify-content-end align-items-end">
                          <p className="mb-0 mr-4">
                            Mostrando {pagingController.data.length} de {pagingController.totalRows} órdenes
                          </p>
                          <TicketingExportButton width="130px" type="button" aria-label="Download CSV" onClick={(e) => downloadOVCSV(e.target.value)}>
                            <p style={{ margin: "0", fontWeight: "800", fontSize: "16px", color: "#062541" }}>Exportar</p>
                            <Share2 color="#293134" className="ml-2" size={20} />
                          </TicketingExportButton>
                        </div>
                      )}
                    </div>
                  }
                  paginationComponentOptions={{ rowsPerPageText: "Ordenes por pagina", rangeSeparatorText: "De", selectAllRowsItemText: "Todos" }}
                  noDataComponent={
                    <div className="p-3">
                      <b>No se encontraron Ordenes de Venta</b>
                    </div>
                  }
                  striped
                  pagination
                  sortServer
                  paginationServer
                  // actions={actions}
                  onRowClicked={handleOrdenClicked}
                  selectableRows
                  onSelectedRowsChange={handleRowSelected}
                  clearSelectedRows={toggleCleared}
                  contextComponent={contextComponent}
                  data={pagingController.data}
                  onSort={pagingController.handleSortsChange}
                  paginationTotalRows={pagingController.totalRows}
                  paginationDefaultPage={parseInt(pagingController.query.page || 1, 10)}
                  onChangeRowsPerPage={pagingController.handleRecordsPerPageChange}
                  paginationPerPage={parseInt(pagingController.query.perpage || 10, 10)}
                  onChangePage={pagingController.handlePageChange}
                  customStyles={tableCustomStylesNP}
                  theme="ordenDeVenta"
                  columns={[
                    {
                      name: "Nro. OV",
                      selector: (row) => (
                        <>
                          <UncontrolledTooltip target={`orden${row.idOrdenDeVenta}`}>Copiar Nro de Orden</UncontrolledTooltip>
                          <button
                            type="button"
                            data-tag="allowRowEvents"
                            id={`orden${row.idOrdenDeVenta}`}
                            style={{ cursor: "pointer", border: "none", background: "none", outline: "none" }}
                            onClick={(event) => {
                              event.stopPropagation();
                              if (row.idOrdenDeVenta) {
                                navigator.clipboard.writeText(row.idOrdenDeVenta.toString());
                                toast.success("Nro de Orden copiado");
                              }
                            }}
                          >
                            {row.idOrdenDeVenta ? row.idOrdenDeVenta : "-"}
                          </button>
                        </>
                      ),
                      id: "idOrdenDeVenta",
                      center: true,
                      width: "150px",
                      sortable: true,
                    },
                    {
                      name: "Razon social",
                      selector: (row) => row.cliente || "-",
                      center: true,
                      sortable: true,
                      id: "cliente",
                      style: {
                        cursor: "pointer",
                      },
                    },
                    {
                      name: "Subcliente",
                      selector: (row) => row.subcliente || "-",
                      center: true,
                      id: "subcliente",
                      sortable: true,
                      style: {
                        cursor: "pointer",
                      },
                    },
                    {
                      name: "Servicio",
                      selector: (row) => row.servicio || "-",
                      center: true,
                      id: "servicio",
                      sortable: true,
                      style: {
                        cursor: "pointer",
                      },
                    },
                    {
                      name: "Periodo",
                      selector: (row) => (row.periodo ? formatPeriodo(row.periodo) : "-"),
                      center: true,
                      id: "periodo",
                      sortable: true,
                      style: {
                        cursor: "pointer",
                      },
                    },
                    {
                      name: "Total a facturar",
                      selector: (row) => (row.total != null ? `$${formatearTotal(row.total)}` : "-"),
                      center: true,
                      id: "total",
                      sortable: true,
                      style: {
                        cursor: "pointer",
                      },
                    },
                    {
                      name: "Responsable",
                      selector: (row) => (row.piResponsable ? row.piResponsable.nombreApellido : "-"),
                      center: true,
                      id: "responsable",
                      sortable: true,
                      style: {
                        cursor: "pointer",
                      },
                    },
                    {
                      name: "Fecha enviada",
                      selector: (row) => (row.fechaEnvioFacturacion ? moment(row.fechaEnvioFacturacion).format("DD/MM/YY") : "-"),
                      center: true,
                      id: "fechaEnvioFacturacion",
                      sortable: true,
                      style: {
                        cursor: "pointer",
                      },
                    },
                    {
                      name: "Estado",
                      id: "estado",
                      selector: (row) =>
                        row.estado ? (
                          <div className="d-flex justify-content-center align-items-center" style={{ gap: "8px" }}>
                            <StatusTagButton
                              $type={getEstadoByValueOV(row.estado)}
                              id={`facturar${row.id}`}
                              onClick={() => {
                                handleClickEnviar(row);
                              }}
                              aria-label="enviar a facturar"
                              type="button"
                              disabled={row.estado !== 1 || enviandoAFacturar === row.idOrdenDeVenta || isAudit}
                            >
                              {enviandoAFacturar === row.idOrdenDeVenta ? (
                                "Enviando..."
                              ) : (
                                <>
                                  {getEstadoByValueOV(row.estado)}
                                  {getIconByStatus(row.estado)}
                                </>
                              )}
                            </StatusTagButton>
                            {downloadingFileId === row.idOrdenDeVenta ? (
                              <Spinner className="ml-2" />
                            ) : (
                              <Download
                                color={!row.fileId ? "#BDBDBD" : "#062541"}
                                size={20}
                                onClick={() => {
                                  if (!row.fileId) {
                                    return;
                                  }
                                  handleDownloadFileOrdenDeVenta(row);
                                }}
                              />
                            )}
                          </div>
                        ) : (
                          ""
                        ),
                      width: "auto !important",
                      center: true,
                      sortable: true,
                      color: "blue",
                      wrap: true,
                      style: {
                        cursor: "pointer",
                        textAlign: "center",
                      },
                    },
                  ]}
                />
              </div>
            </div>
          </div>
        </div>
      </BlurSpinner>
    </>
  );
};

export default withRouter(ModuloOrdenesDeVenta);
